import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaModel } from '../../../_model/media/media.model';
import { SafeUrl } from '@angular/platform-browser';

/**
 * Opens a 'gallery' view for whichever images are passed in, starting at the specific index passed in (or 0).
 * Expected to be used with the MediaModel, since that's really all the images we deal with
 */
@Component({
    template: `
    <div class="gallery-container">
      <div *ngIf="data.files?.length > 1" class="gallery-count">
        {{data.index+1}}/{{data.files?.length}}
      </div>
      <mat-icon matRipple matRippleColor="rgba(255, 255, 255, 0.1)" class="gallery-close" (click)="close()">
        close
      </mat-icon>
      <div class="gallery-name">{{data.files[data.index].originalMediaName}}</div>
      <mat-icon matRipple matRippleColor="rgba(255, 255, 255, 0.1)" class="gallery-prev"
                *ngIf="data.index !== 0" (click)="prev()">
        chevron_left
      </mat-icon>
      <mat-icon matRipple matRippleColor="rgba(255, 255, 255, 0.1)" class="gallery-next"
                *ngIf="data.index < data.files.length-1" (click)="next()">
        chevron_right
      </mat-icon>
      <div class="gallery-image-container">
        <img (load)="loading = false" [style.display]="loading ? 'none' : 'initial'" class="gallery-image" [src]="source"/>
        <mat-spinner *ngIf="loading" class="gallery-spinner"></mat-spinner>
      </div>
      <div *ngIf="data.files?.length > 1" class="gallery-navbar">
        <div></div>
        <img *ngFor="let file of data.files; index as i" class="gallery-navbar-item" (click)="set(i)" [src]="getThumbnail(i)" />
      </div>
    </div>
  `,
    styleUrls: ['./_dialog.scss'],
    standalone: false
})
export class GalleryDialog {

  public loading: boolean = true;

  public get source(): SafeUrl {
    return this.data.files[this.data.index].photoUrls.length ?
      this.data.files[this.data.index].getPhotoUrl('Large') :
      this.data.files[this.data.index].localUrl;
  }

  public getThumbnail(i: number): SafeUrl {
    return this.data.files[i].photoUrls.length ?
      this.data.files[i].getPhotoUrl('Thumbnail') :
      this.data.files[i].localUrl;
  }

  constructor(
    private self: MatDialogRef<GalleryDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      files: MediaModel[],
      index?: number
    }
  ) {
    if (!data.index) data.index = 0;
  }

  public prev() {
    this.loading = true;
    this.data.index--;
  }

  public next() {
    this.loading = true;
    this.data.index++;
  }

  public set(i: number) {
    if (this.data.index !== i) {
      this.loading = true;
      this.data.index = i;
    }
  }

  public close() {
    this.self.close();
  }
}

export const GalleryDialogConfig = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  panelClass: 'fullscreen-dialog'
}
